import { defineMessages } from 'react-intl'

const baseId = 'service_types_management'

export default defineMessages({
  header: {
    id: `${baseId}.header`,
    defaultMessage: 'Service Types Management',
  },
})
